// @module TavanoTeam.CSExtensions.CSCertCapture.Collection
define('TavanoTeam.CSExtensions.CSCertCapture.Collection'
,   [
        'TavanoTeam.CSExtensions.CSCertCapture.Model'
    ,   'SC.Configuration'
        
    ,   'Utils'
    ,   'Backbone'
    ]
,   function(
        CertCaptureModel
    ,   Configuration
    
    ,   Utils
    ,   Backbone
    )
{
    'use strict';

    return Backbone.Collection.extend({
        model: CertCaptureModel
    ,   url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/CSCertCaptureExt.Service.ss'))
    ,   parse: function(response)
        {
            this.totalRecordsFound = response.total;
            this.recordsPerPage = response.per_page;

            return response.data;
        }
    ,   update: function(options)
        {
            var data = {
                filter: options.filter.value
            ,   filterAction: 'filter-cert'
            };

            this.fetch({
                data: data
            ,   reset: true
            ,   killerId: options.killerId
            });
        }
    });
});
